$(document).ready(function(){
  
  var product_handle = $('#product-handle-for-fb').text();
  var url = 'http://shop.holstee.com/products/'+product_handle;
  var data = 'https://graph.facebook.com/?id='+url;      

  var total_coments_product = 0;
  $.ajax({ 
      type: 'GET', 
      url: data, 
      async: false,
      contentType: "application/json", 
      dataType: 'jsonp', 
      success: function(r) { 

        if(r.comments){
          total_coments_product = r.comments;
        } 

      }, 
      error: function(e) { 
      }

  });


 var words = []; 
 words = $('#count-words-product-description').text().split(/\b[\s,\.\-:;]*/);
  if(parseInt(words.length) <= 70){
  	$('#hide-if-words').hide();
  }
  
  
  
  $('#trigger-description').click(function(e){
    e.preventDefault();
    var pos_description = $('ul.product__tabs').offset().top;

    $('html, body').animate({
        scrollTop: (pos_description - 50)
    }, 500);

  	$("#description-below").trigger( "click" );
  });
  
  $('#trigger-shipping').click(function(e){
    e.preventDefault();
    var pos_shipping = $('ul.product__tabs').offset().top;

    $('html, body').animate({
        scrollTop: (pos_shipping - 50)
    }, 500);

  	$("#shipping-below").trigger( "click" );
  });

});